import { createStore, applyMiddleware, compose } from 'redux';
import {preloadedState} from './preloadedState';
import rootReducer from '../reducers';
import middleware from '../middleware';
import DevTools from '../containers/DevTools';

export default createStore(
  rootReducer, 
  preloadedState, 
  compose(
    applyMiddleware( ...middleware ), 
    DevTools.instrument()
  )
);



// WEBPACK FOOTER //
// ./usr/lib/ui/src/store/store.dev.js